import { render, staticRenderFns } from "./TeamMemberDocumentReportMatrix.vue?vue&type=template&id=48d6e8bc&scoped=true&"
import script from "./TeamMemberDocumentReportMatrix.vue?vue&type=script&lang=js&"
export * from "./TeamMemberDocumentReportMatrix.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberDocumentReportMatrix.vue?vue&type=style&index=0&id=48d6e8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6e8bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d6e8bc')) {
      api.createRecord('48d6e8bc', component.options)
    } else {
      api.reload('48d6e8bc', component.options)
    }
    module.hot.accept("./TeamMemberDocumentReportMatrix.vue?vue&type=template&id=48d6e8bc&scoped=true&", function () {
      api.rerender('48d6e8bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/components/TeamMemberDocumentReportMatrix.vue"
export default component.exports